export default __webpack_public_path__ + "static/client_img2-7504b2daaa450aced3c7262f00d6a237.webp";